// Normaliza strings para ordenar/buscar sin romper con null/undefined
export const normalizeString = (v) =>
  String(v ?? "")
    .trim()
    .toLowerCase();

// Sorter genérico para strings (null-safe)
export const stringSorter =
  (field, { ndLast = true } = {}) =>
  (a, b) => {
    const sa = a?.[field];
    const sb = b?.[field];

    const aEmpty = sa === null || sa === undefined || sa === "";
    const bEmpty = sb === null || sb === undefined || sb === "";

    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return ndLast ? 1 : -1;
    if (bEmpty) return ndLast ? -1 : 1;

    return String(sa).localeCompare(String(sb));
  };

// Sorter genérico para números (null-safe)
export const numberSorter =
  (field, { ndLast = true, nullAs = null } = {}) =>
  (a, b) => {
    const naRaw = a?.[field];
    const nbRaw = b?.[field];

    const na =
      naRaw === null || naRaw === undefined || naRaw === ""
        ? nullAs
        : Number(naRaw);
    const nb =
      nbRaw === null || nbRaw === undefined || nbRaw === ""
        ? nullAs
        : Number(nbRaw);

    const aInvalid = na === null || Number.isNaN(na);
    const bInvalid = nb === null || Number.isNaN(nb);

    if (aInvalid && bInvalid) return 0;
    if (aInvalid) return ndLast ? 1 : -1;
    if (bInvalid) return ndLast ? -1 : 1;

    return na - nb;
  };

// Helpers para fechas
export const getTimeOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const d = new Date(value);
  const t = d.getTime();
  return Number.isNaN(t) ? null : t;
};

// Sorter genérico para fechas (null-safe)
export const dateSorter =
  (field, { ndLast = true } = {}) =>
  (a, b) => {
    const ta = getTimeOrNull(a?.[field]);
    const tb = getTimeOrNull(b?.[field]);

    if (ta === null && tb === null) return 0;
    if (ta === null) return ndLast ? 1 : -1;
    if (tb === null) return ndLast ? -1 : 1;

    return ta - tb;
  };
